export enum EventTypeId {
    Sports = 1,
    Trips = 2,
    SignUps = 3,
    Other = 4,
    System = 5
  }